import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label } from 'components';
import { ReactComponent as ImgApproveCheck } from 'assets/img/status/img_user_approve_check.svg';

interface Props {
    name: string;
    phone: string;
    birthday: string;
}

function ApproveCheck({ name, phone, birthday }: Props): React.ReactElement {
    return (
        <FormStatusInfo subTitle={['승인 대기중입니다.']} image={<ImgApproveCheck />}>
            <S.CaptionWrapper>
                <Label contents={'등록하신 직원분 등록 승인 대기중입니다. 승인 기간은 2~3일 정도 걸립니다.'} color={'gray_opacity_600'} fontStyle={'body2'} />
            </S.CaptionWrapper>
            <S.InfoWrapper>
                <Label contents={'이름'} color={'gray_opacity_600'} fontStyle={'body2'} />
                <Label contents={name} color={'gray_opacity_800'} fontStyle={'body1'} />
            </S.InfoWrapper>
            <S.InfoWrapper>
                <Label contents={'권한'} color={'gray_opacity_600'} fontStyle={'body2'} />
                <Label contents={'직원'} color={'gray_opacity_800'} fontStyle={'body1'} />
            </S.InfoWrapper>
            <S.InfoWrapper>
                <Label contents={'전화번호'} color={'gray_opacity_600'} fontStyle={'body2'} />
                <Label contents={phone} color={'gray_opacity_800'} fontStyle={'body1'} />
            </S.InfoWrapper>
            <S.InfoWrapper>
                <Label contents={'생년월일'} color={'gray_opacity_600'} fontStyle={'body2'} />
                <Label contents={birthday} color={'gray_opacity_800'} fontStyle={'body1'} />
            </S.InfoWrapper>
        </FormStatusInfo>
    );
}

export default ApproveCheck;
